<template>
  <GModal v-show="isOpenCategoriesMobile" ref="modalFilterBrand" class="modal--full-fixed modal--filter-by-category">
    <div slot="header">
      <button type="button" class="close" aria-label="Close" style="right: inherit !important">
        <img src="/assets/img/arrow_left.svg" alt="SOCO" @click.prevent="closeModal" />
      </button>
      <h2 class="modal-heading">Browse By Categories</h2>
    </div>
    <div slot="body" class="content">
      <div class="container">
        <div class="list-category">
          <div class="row-list-category">
            <div class="col-department">
              <ul v-if="categoriesOfDepartment.length" class="list-department">
                <li
                  v-for="(deparment, key) in categoriesOfDepartment"
                  :key="key"
                  :class="{ active: tabCategoryActive === deparment['_id'] }"
                  @click.prevent="changedCategoryList(deparment['_id'], deparment['name'])"
                >
                  <img :src="showImageBasedOnCategory(deparment)" class="menu-image" height="32" width="32" />
                  <span>{{ deparment.name }}</span>
                </li>
              </ul>
            </div>
            <div class="col-categories">
              <template v-for="(items, id) in categoriesOfDepartment">
                <div v-show="tabCategoryActive === items._id" :key="id" class="category-wrapper">
                  <router-link
                    :to="`/category/${items.my_soco_sql_id}/${$options.filters.slug(items.name)}`"
                    class="link-category-detail"
                    @click.native="closeModal"
                  >
                    See all {{ tabCategoryActiveName }} &nbsp;
                    <img src="/assets/img/arrow_carrot-right.svg" alt="icon-next" loading="lazy" width="7" height="8" />
                  </router-link>
                  <ul class="list list-category-items">
                    <li v-for="(item, key) in items.children" v-show="item.children" :key="key" class="heading">
                      <router-link
                        :to="`/category/${item.my_soco_sql_id}/${$options.filters.slug(item.name)}`"
                        @click.native="closeModal"
                      >
                        {{ item.name }}&nbsp;
                        <img
                          src="/assets/img/arrow_carrot-right.svg"
                          alt="icon-next"
                          loading="lazy"
                          width="7"
                          height="8"
                        />
                      </router-link>
                      <ul class="subitem_menu">
                        <li v-for="(subitem, i) in item.children" :key="i">
                          <router-link
                            :to="`/category/${subitem.my_soco_sql_id}/${$options.filters.slug(subitem.name)}` || '/'"
                            @click.native="closeModal"
                          >
                            {{ subitem.name }}&nbsp;
                            <img
                              src="/assets/img/arrow_carrot-right.svg"
                              alt="icon-next"
                              loading="lazy"
                              width="7"
                              height="8"
                            />
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </GModal>
</template>
<script>
export default {
  name: 'browse-category-mobile',
  data() {
    return {
      isLoadingFinishPopularProduct: false,
      showCategoriesOverlay: false,
      categoryName: '',
    };
  },
  computed: {
    categoriesOfDepartment() {
      return this.$store.state.header.categoriesOfDepartment;
    },
    isOpenCategoriesMobile() {
      return this.$store.state.header.showCategoriesMobile;
    },
    tabCategoryActive() {
      return this.$store.state.header.tabCategoryActive;
    },
    tabCategoryActiveName() {
      return this.$store.state.header.tabCategoryActiveName;
    },
    listCategories() {
      return this.$store.state.header.listCategoryMobile;
    },
  },
  watch: {
    $route() {
      this.$store.commit('SET_TAB_CATEGORY_ACTIVE', this.categoriesOfDepartment[0]._id);
    },
  },
  mounted() {
    this.$store.commit('SET_TAB_CATEGORY_ACTIVE', this.$store.state.header.categoriesOfDepartment[0]._id);
    this.$store.commit('SET_TAB_CATEGORY_ACTIVE_NAME', this.$store.state.header.categoriesOfDepartment[0].name);
  },
  methods: {
    getCategoriesMenu() {
      if (this.$store.state.$_Header.department_menu.length == 0) {
        this.$store.dispatch('$_Header/getDepartmentMenu', this);
      }
    },
    mainImage(src) {
      return this.$options.filters.imageCdn({
        config: 'w=72',
        image: src,
      });
    },
    changedCategoryList(deparmentId, departmentName) {
      this.$store.commit('SET_TAB_CATEGORY_ACTIVE', deparmentId);
      this.$store.commit('SET_TAB_CATEGORY_ACTIVE_NAME', departmentName);
    },
    closeModal() {
      this.$store.commit('SET_SHOW_CATEGORY', false);
    },
    isLillaCategory(slug) {
      return ['for-moms', 'for-baby-kids'].includes(slug);
    },
    showImageBasedOnCategory(menu) {
      let image = '';
      if (this.isLillaCategory(menu.slug)) {
        image = menu.lulla_logo;
      } else {
        image = menu.logo;
      }
      if (!image) {
        image = 'https://images.soco.id/f2a92eb6-86ed-4e6a-b937-38d39416ddae-15140109598.png';
      }
      return image;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 !important;
  height: 100vh;
  .list-category {
    width: 100%;
    height: 100vh;
    .row-list-category {
      display: flex;
      height: 100%;
      .col-department {
        flex-basis: 164px;
        position: relative;
        background: #fdf7f7;
      }
      .col-categories {
        position: relative;
        padding: 11px 13px 0 13px;
        flex-basis: calc(100% - 164px);
      }
    }
  }
  .list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  .category-wrapper {
    max-height: 100%;
    overflow-y: auto;
  }
  .link-category-detail {
    font: 14px/20px 'lato-bold', sans-serif;
    color: #eb395f;
    display: block;
    margin-bottom: 10px;
  }
  .list-department {
    height: 100%;
    overflow-y: auto;
    > li {
      padding: 10px 16px;
      background-color: #fdf7f7;
      font: 12px/17px 'lato-regular', sans-serif;
      color: #231f20;
      border-bottom: 1px solid #e5e5e5;
      &.active {
        background-color: #ffffff;
        border-bottom: none;
      }
    }
    span {
      font: 12px/17px 'lato-regular', sans-serif;
      margin-left: 8px;
    }
  }

  .list-category-items {
    > li {
      font: 14px/20px 'lato-regular', sans-serif;
      color: #333333;
      margin-bottom: 8px;
      &.heading {
        font-size: 13px;
        line-height: 18px;
        font-family: 'lato-bold', sans-serif;
        margin-bottom: 11px;
        margin-top: 25px;
        > a {
          color: #231f20;
        }
      }

      &:first-child {
        margin-top: 0 !important;
      }

      > a {
        color: #333333;
      }
      .subitem_menu {
        padding: 0;
        margin: 11px 0 0;
        list-style-type: none;
        li {
          font: 14px/18px 'lato-regular', sans-serif;
          color: #333333;
          margin-bottom: 8px;
          letter-spacing: 0;
        }
      }
    }
  }
}
.menu-image {
  border-radius: 50%;
}
</style>
